module.exports = __webpack_public_path__ + "img/bar-counter-stools.febf3aa.jpg";